import Icon from "@/v2-ui/icon"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"
import { getLayerConsolePreviewUrl } from "@/v2-backoffice-client/layer/review/layer.review.utils"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"

export type LayerConsolePreviewButtonProps = TooltipButtonProps & {
  layer: LayerFragment
}

/**
 * Hot-link into the v2-console of the same environment with the layer
 * force-loaded on the map (even while it is still disabled), so an operator
 * can test a pending layer before publishing it.
 */
function LayerConsolePreviewButton(props: LayerConsolePreviewButtonProps) {
  const { layer, children, ...buttonProps } = props

  const href = getLayerConsolePreviewUrl(layer.FeatureCode)

  return (
    // asChild: Radix Slot allows exactly one child, so the icon lives inside
    // the anchor instead of going through Button's iconSrc prop.
    <TooltipButton
      asChild
      size="sm"
      variant="ghost"
      content="Open the console with this layer force-loaded on the map — works before it goes live"
      {...buttonProps}
    >
      <a href={href} target="_blank" rel="noreferrer">
        <Icon src="map" size={14} />
        {children ?? "Preview"}
      </a>
    </TooltipButton>
  )
}

export default LayerConsolePreviewButton
